document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-open-user-delete]')
  if (!button) return
  document.getElementById(button.dataset.openUserDelete)?.showModal()
})

document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('.user-delete-dialog[open]').forEach((dialog) => dialog.close())
})
